
const  Logo = ({w="10%"}) =>{

    return(
        <img src="https://unlock-m.com.br/assets/logo-mconsulta250x250.png" width={w} alt="Logo Unlock-M" />
    )
}

export default Logo;